"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorMessageFromValidation = exports.validateWithThrow = void 0;
var class_validator_1 = require("class-validator");
var http_errors_1 = __importDefault(require("http-errors"));
function validateWithThrow(object) {
    var validations = class_validator_1.validateSync(object, { skipMissingProperties: true });
    var errorMessage = getErrorMessageFromValidation(validations);
    if (errorMessage) {
        throw http_errors_1.default(400, errorMessage);
    }
    else {
        return;
    }
}
exports.validateWithThrow = validateWithThrow;
function getErrorMessageFromValidation(validations) {
    var e_1, _a;
    try {
        for (var validations_1 = __values(validations), validations_1_1 = validations_1.next(); !validations_1_1.done; validations_1_1 = validations_1.next()) {
            var validation = validations_1_1.value;
            var errorMessage = validateSingularError(validation);
            if (errorMessage) {
                return errorMessage;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (validations_1_1 && !validations_1_1.done && (_a = validations_1.return)) _a.call(validations_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
}
exports.getErrorMessageFromValidation = getErrorMessageFromValidation;
function validateSingularError(validation) {
    var e_2, _a;
    if (!(validation === null || validation === void 0 ? void 0 : validation.children))
        return null;
    var constraints = validation.constraints;
    for (var key in constraints) {
        if (constraints[key]) {
            return constraints[key];
        }
    }
    try {
        for (var _b = __values(validation.children), _c = _b.next(); !_c.done; _c = _b.next()) {
            var child = _c.value;
            var errorMessage = validateSingularError(child);
            if (errorMessage) {
                return errorMessage;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return null;
}
//# sourceMappingURL=Validation.js.map